import { useMemo } from "react";

const START_HOUR = 8;
const END_HOUR = 21;
const SLOT_HEIGHT = 30;

const useWeekCalendar = (date) => {
  const days = useMemo(() => {
    const start = new Date(date);

    start.setDate(start.getDate() - start.getDay());

    return Array.from({ length: 7 }, (_, index) => {
      const day = new Date(start);

      day.setDate(start.getDate() + index);

      return day;
    });
  }, [date]);

  const timeSlots = useMemo(() => {
    const slots = [];
    for (let h = START_HOUR; h < END_HOUR; h++) {
      slots.push(`${String(h).padStart(2, "0")}:00`);
      slots.push(`${String(h).padStart(2, "0")}:10`);

      slots.push(`${String(h).padStart(2, "0")}:20`);
      slots.push(`${String(h).padStart(2, "0")}:30`);
      slots.push(`${String(h).padStart(2, "0")}:40`);
      slots.push(`${String(h).padStart(2, "0")}:50`);
    }

    return slots;
  }, []);

  const getTop = (time) => {
    const [hour, minute] = time.split(":").map(Number);
    console.log(time); //15:45
    return ((hour - START_HOUR) * 6 + minute / 10) * SLOT_HEIGHT;
  };

  const getHeight = (start, end) => {
    const [sh, sm] = start.split(":").map(Number);

    const [eh, em] = end.split(":").map(Number);

    const minutes = eh * 60 + em - (sh * 60 + sm);

    return (minutes / 10) * SLOT_HEIGHT - 1;
  };

  const sameDay = (date1, date2) => {
    return (
      date1.getDate() === date2.getDate() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getFullYear() === date2.getFullYear()
    );
  };

  const isToday = (day) => {
    const today = new Date();

    return today.toDateString() === day.toDateString();
  };

  return {
    days,
    timeSlots,
    getTop,
    getHeight,
    sameDay,
    isToday,
  };
};

export default useWeekCalendar;
